export const wijzigenAdresgegevensEn = {
  AdresGegevensWijzigenFormulierStapGegevensWijzigen: "Change personal details",
  MijnPostadresWijzigen: "Change or pass on my postal address",
  MijnWoonadresEnPostadresWijzigen: "Change my home and postal address",
  MijnWoonadresWijzigen: "Change my home address"
};
